module.exports = __webpack_public_path__ + "img/1557614072836464642.5e8eb760.png";